module.exports = __webpack_public_path__ + "audio/fourAudio.25a94be4.mp3";